import React, { ChangeEvent, MouseEvent } from "react";
import { ContainerCheckBox } from "src/scenes/TermsOfUse/styles";
import { LinkTerms } from "src/scenes/V2/TermsOfUse/style";
import Config from "../config";
import Checkbox from "./Checkbox";

type Props = {
  checked: boolean;
  serviceId: string;
  globoId: string;
  setChecked: (checked: boolean) => void;
};

export const CheckboxComponent = ({
  checked,
  serviceId,
  setChecked,
}: Props) => {
  const termsLink = Config.TERMS_OF_USE_URL + serviceId;
  const privacyPolicyLink = Config.PRIVACY_POLICY_URL;

  const handleCheckboxChange = (event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    setChecked(!checked);
  };

  const redirectToTerms = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(termsLink, "_blank");
  };

  const redirectToPrivacyPolicy = (e: MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    window.open(privacyPolicyLink, "_blank");
  };

  return (
    <ContainerCheckBox>
      <Checkbox checked={checked} toggle={handleCheckboxChange}>
        Li e concordo com os{" "}
        <LinkTerms onClick={redirectToTerms} tabIndex={0} target="_blank">
          Termos de Uso
        </LinkTerms>{" "}
        e a{" "}
        <LinkTerms
          onClick={redirectToPrivacyPolicy}
          tabIndex={0}
          target="_blank"
        >
          Política de Privacidade.
        </LinkTerms>
      </Checkbox>
    </ContainerCheckBox>
  );
};
